import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const CustomOptions = createSvgIcon(
  <path d="M24 5.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Zm-5.5 3.25a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5ZM4.375 9.966l6.591-6.591-1.591-1.591-5 5-2.5-2.5L.284 5.875l4.091 4.091ZM5.5 24a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Zm3.25-5.5a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0ZM18.5 24a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Zm3.25-5.5a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z" />,
  'CustomOptions'
);

export { CustomOptions };